import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button, Input } from "reactstrap";
import { MdAdd } from "react-icons/md";
import Pagination from "../../Components/Paginate";
import { useSelector } from "react-redux";

const STATE_HEADER_TYPES = [
  "Overview",
  "Popular Destinations",
  "Things to See & Do",
  "Featured Experience",
  "Check This Out",
];

const StateHeaderIndex = () => {
  const { AuthReducer: { auth } } = useSelector((state) => state);
  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [paginate, setPaginate] = useState(20);
  const [search, setSearch] = useState("");
  const [stateFilter, setStateFilter] = useState("");
  const [states, setStates] = useState([]);
  const [sort, setSort] = useState("desc");

  const fetchList = () => {
    setLoading(true);
    const params = new URLSearchParams({
      limit: paginate,
      page,
      sort,
    });
    if (search) params.set("search", search);
    if (stateFilter) params.set("state_id", stateFilter);
    axios
      .get(`/api/admin/v1/state-header-list?${params}`, {
        headers: { Authorization: `Bearer ${auth?.token}` },
      })
      .then((res) => {
        setList(res.data.stateHeaders || []);
        setCount(res.data.count || 0);
      })
      .catch(() => toast.error("Failed to load state headers"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchList();
  }, [page, paginate, sort, search, stateFilter]);

  useEffect(() => {
    axios
      .get("/api/admin/v1/state-lists?limit=500&page=0", {
        headers: { Authorization: `Bearer ${auth?.token}` },
      })
      .then((res) => setStates(res.data?.StateLists || res.data?.states || []))
      .catch(() => {});
  }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this state header?"))
      return;
    axios
      .delete(`/api/admin/v1/state-header-list/${id}`, {
        headers: { Authorization: `Bearer ${auth?.token}` },
      })
      .then((res) => {
        toast.success(res.data?.message || "Deleted successfully");
        fetchList();
      })
      .catch((err) =>
        toast.error(err.response?.data?.message || "Something went wrong")
      );
  };

  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white fs-4">State Header List</h5>
            <Link to="/add-state-header">
              <Button className="bg-white text-black" size="sm">
                <span className="me-2">
                  <MdAdd size={22} />
                </span>
                Add State Header
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div
        className="bg-white px-3 py-4 rounded-2 my-4"
        style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}
      >
        <div className="row mb-3">
          <div className="col-md-2">
            <Input
              size="sm"
              value={search}
              placeholder="Search by type"
              onChange={({ target: { value } }) => setSearch(value)}
            />
          </div>
          <div className="col-md-2">
            <Input
              type="select"
              size="sm"
              value={stateFilter}
              onChange={({ target }) => setStateFilter(target.value)}
            >
              <option value="">All States</option>
              {states.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.state_name}
                </option>
              ))}
            </Input>
          </div>
          <div className="col-md-2">
            <Input
              type="select"
              size="sm"
              value={sort}
              onChange={({ target }) => setSort(target.value)}
            >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
        </div>
        <div className="col-md-12">
          <Table hover responsive>
            <thead>
              <tr>
                <th>SL. No.</th>
                <th>State</th>
                <th>Header Type</th>
                <th>Parent Header</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6">Loading...</td>
                </tr>
              ) : list.length === 0 ? (
                <tr>
                  <td colSpan="6">No data found</td>
                </tr>
              ) : (
                list.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">{index + 1 + page * paginate}</th>
                    <td>{item.State?.state_name || "-"}</td>
                    <td>{item.name}</td>
                    <td>{item.Parent?.name || "—"}</td>
                    <td>{item.status ? "Active" : "Inactive"}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to={`/edit-state-header/${item.id}`}>
                          <AiOutlineEdit
                            size={22}
                            className="text-warning me-3"
                          />
                        </Link>
                        <AiOutlineDelete
                          size={22}
                          className="text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDelete(item.id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
        <div className="row align-items-center mt-3">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                onChange={(e) => setPaginate(Number(e.target.value))}
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Input>
            </div>
            <div className="col-md-10 text-black d-flex align-items-center ps-3">
              {count > 0
                ? `Showing ${indexOfFirstItem + 1} to ${Math.min(indexOfLastItem, count)} of ${count} entries`
                : "Showing 0 to 0 of 0 entries"}
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-end">
              <Pagination
                pageCount={Math.ceil(count / paginate) || 1}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateHeaderIndex;
